import { createRouter, createWebHistory } from 'vue-router'
//import RengongYlqRwTestView from '../views/rengongcuiping/RengongYlqRwKFView.vue'

const routes = [
  {
    path: '/',
    name: 'internalhome',
    component: () => import('../views/zhiboIframe/zhiboIframeAutoView.vue')
  },
  {
    path: '/internalhome',
    name: 'internalhome',
    component: () => import('../views/zhiboIframe/zhiboIframeAutoView.vue')
  },
  {
    path: '/internaldzhFP',//多账号发评
    name: 'internaldzhFP',
    component: () => import('../views/zhiboIframe/zhiboIframeDZHView.vue')
  },
  {
    path: '/internalpay',
    name: 'internalpay',
    component: () => import('../views/zhiboIframe/zhiboIframePayView.vue')
  },
  {
    path: '/internalbuyin',
    name: 'internalbuyin',
    component: () => import('../views/buyin/buyinlistView.vue')
  },
  {
    path: '/internalbuyintanchuang',
    name: 'internalbuyintanchuang',
    component: () => import('../views/buyin/buyintanchuangView.vue')
  },
  {
    path: '/internalbuyinFaPing',
    name: 'internalbuyinFaPing',
    component: () => import('../views/buyin/buyinFaPingView.vue')
  },
  {
    path: '/internalbuyinHuiPing',
    name: 'internalbuyinHuiPing',
    component: () => import('../views/buyin/buyinHuiPingView.vue')
  },
  {
    path: '/internaldoudian',
    name: 'internaldoudian',
    component: () => import('../views/doudian/doudianlistView.vue')
  },
  {
    path: '/internaldoudiantanchuang',
    name: 'internaldoudiantanchuang',
    component: () => import('../views/doudian/doudiantanchuangView.vue')
  },
  {
    path: '/internaldoudianFaPing',
    name: 'internaldoudianFaPing',
    component: () => import('../views/doudian/doudianFaPingView.vue')
  },
  {
    path: '/internaldoudianHuiPing',
    name: 'internaldoudianHuiPing',
    component: () => import('../views/doudian/doudianHuiPingView.vue')
  },
  {
    path: '/internalbendi',
    name: 'internalbendi',
    component: () => import('../views/bendi/bendilistView.vue')
  },
  {
    path: '/internalbenditanchuang',
    name: 'internalbenditanchuang',
    component: () => import('../views/bendi/benditanchuangView.vue')
  },
  {
    path: '/internalbendiFaPing',
    name: 'internalbendiFaPing',
    component: () => import('../views/bendi/bendiFaPingView.vue')
  },
  {
    path: '/internalbendiHuiPing',
    name: 'internalbendiHuiPing',
    component: () => import('../views/bendi/bendiHuiPingView.vue')
  },{
    path: '/internalweixin',
    name: 'internalweixin',
    component: () => import('../views/weixin/weixinlistView.vue')
  },  
  {
    path: '/internalkwaishou',
    name: 'internalkwaishou',
    component: () => import('../views/kwaishou/kwaishoulistView.vue')
  },
  {
    path: '/internaldoudianjsls',
    name: 'internaldoudianjsls',
    component: () => import('../views/doudianjsls/doudianjslslistView.vue')
  },
  {
    path: '/internalxiaohongshu',
    name: 'internalxiaohongshu',
    component: () => import('../views/xiaohongshu/xiaohongshulistView.vue')
  },
  {
    path: '/internaldouyinwww',
    name: 'internaldouyinwww',
    component: () => import('../views/douyinwww/douyinwwwlistView.vue')
  },
  {
    path: '/internaltaobao',
    name: 'internaltaobao',
    component: () => import('../views/taobao/taobaolistView.vue')
  },
  /*{
    path: '/zcpSuccessList',
    name: 'zcpSuccessList',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../views/zcp/zcpSuccessListView.vue')
  },*/
]
const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
